"use client";

type ResetAllJobsButtonProps = {
  onClick: () => void;
  className?: string;
};

export default function ResetAllJobsButton({
  onClick,
  className = "",
}: ResetAllJobsButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 px-6 py-2 bg-blue-main text-white font-semibold rounded-full hover:bg-blue-main/90 transition-colors cursor-pointer ${className}`.trim()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
          clipRule="evenodd"
        />
      </svg>
      Ver todas as vagas
    </button>
  );
}
